// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"b836d3d7","977":"6cfed896"}[chunkId] + ".chunk.js";
};